import { z } from 'zod';

export const FirstnameSchema = z
	.string()
	.min(2, { message: 'Must be at least 2 characters long' })
	.regex(/^[\p{L}]+$/u, { message: 'Only letters are allowed' });

export const LastnameSchema = z
	.string()
	.min(2, { message: 'Must be at least 2 characters long' })
	.regex(/^[\p{L}]+$/u, { message: 'Only letters are allowed' });
